module.exports = __webpack_public_path__ + "static/media/imageLoader.3b8cb653.gif";